<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.prokuror_klubi')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="text-center mt-2">
                          <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('prokurorklubi.title')}}</span></div>
                        </div>
                      <div class="mt-3 py-3 text-center">
                        <div class="row">
                          <div class="col-lg-12">
                            <el-collapse v-model="activeName" accordion>
                              <el-collapse-item :title="$t('prokurorklubi.kitob')"
                                                name="1" class="text-center">
                                                                <p style="text-align: justify;" v-html="$t('prokurorklubi.kitob_savol')"></p>
                              </el-collapse-item>
                              <el-collapse-item :title="$t('prokurorklubi.kitob2')"
                                                name="2" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.kitob_savol2')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.konstitutsiya.title')"
                                                name="3" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.konstitutsiya.konstitutsiya_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.prokuratura_togrisidagi_qonun.title')"
                                                name="4" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.prokuratura_togrisidagi_qonun.prokuratura_togrisidagi_qonun_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.jinoyat_kodeksi.title')"
                                                name="5" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.jinoyat_kodeksi.jinoyat_kodeksi_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.jinoyat_protsessual_kodeksi.title')"
                                                name="6" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.jinoyat_protsessual_kodeksi.jinoyat_protsessual_kodeksi_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.mamuriy_javobgarlik.title')"
                                                name="7" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.mamuriy_javobgarlik.mamuriy_javobgarlik_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.jinoyat_ijroiya.title')"
                                                name="8" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.jinoyat_ijroiya.jinoyat_ijroiya_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.fuqarolik_kodeksi.title')"
                                                name="9" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.fuqarolik_kodeksi.fuqarolik_kodeksi_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.fuqarolik_protsessual.title')"
                                                name="10" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.fuqarolik_protsessual.fuqarolik_protsessual_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.mehnat_kodeksi.title')"
                                                name="11" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.mehnat_kodeksi.mehnat_kodeksi_savol')"></p>
                              </el-collapse-item>

                              <el-collapse-item :title="$t('prokurorklubi.murojaat_bilan_ishlash.title')"
                                                name="12" class="text-center">
                                <p style="text-align: justify;" v-html="$t('prokurorklubi.murojaat_bilan_ishlash.murojaat_bilan_ishlash_savol')"></p>
                              </el-collapse-item>
                            </el-collapse>
                            <div>
                              <span></span>
                              <img src="../../public/img/tarixiy1.jpg" alt="img.jpg">
                              <img src="../../public/img/tarixiy2.jpg" alt="img.jpg">
                            </div>
                          </div>
                        </div>

                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
